import type { NDateLocale } from './enUS'
import { zhTW } from 'date-fns/locale'

const datezhTW: NDateLocale = {
  name: 'zh-TW',
  locale: zhTW
}

export default datezhTW
